import frame0 from "./0.png";
import frame1 from "./1.png";
import frame10 from "./10.png";
import frame11 from "./11.png";
import frame12 from "./12.png";
import frame13 from "./13.png";
import frame14 from "./14.png";
import frame15 from "./15.png";
import frame16 from "./16.png";
import frame17 from "./17.png";
import frame18 from "./18.png";
import frame19 from "./19.png";
import frame2 from "./2.png";
import frame20 from "./20.png";
import frame21 from "./21.png";
import frame22 from "./22.png";
import frame23 from "./23.png";
import frame24 from "./24.png";
import frame25 from "./25.png";
import frame26 from "./26.png";
import frame27 from "./27.png";
import frame28 from "./28.png";
import frame29 from "./29.png";
import frame3 from "./3.png";
import frame30 from "./30.png";
import frame31 from "./31.png";
import frame32 from "./32.png";
import frame33 from "./33.png";
import frame34 from "./34.png";
import frame35 from "./35.png";
import frame36 from "./36.png";
import frame37 from "./37.png";
import frame38 from "./38.png";
import frame39 from "./39.png";
import frame4 from "./4.png";
import frame40 from "./40.png";
import frame41 from "./41.png";
import frame42 from "./42.png";
import frame43 from "./43.png";
import frame44 from "./44.png";
import frame45 from "./45.png";
import frame46 from "./46.png";
import frame47 from "./47.png";
import frame48 from "./48.png";
import frame49 from "./49.png";
import frame5 from "./5.png";
import frame50 from "./50.png";
import frame51 from "./51.png";
import frame52 from "./52.png";
import frame53 from "./53.png";
import frame54 from "./54.png";
import frame55 from "./55.png";
import frame56 from "./56.png";
import frame57 from "./57.png";
import frame58 from "./58.png";
import frame59 from "./59.png";
import frame6 from "./6.png";
import frame7 from "./7.png";
import frame8 from "./8.png";
import frame9 from "./9.png";
export const speaking_1: string[] = [
  frame0,
  frame1,
  frame2,
  frame3,
  frame4,
  frame5,
  frame6,
  frame7,
  frame8,
  frame9,
  frame10,
  frame11,
  frame12,
  frame13,
  frame14,
  frame15,
  frame16,
  frame17,
  frame18,
  frame19,
  frame20,
  frame21,
  frame22,
  frame23,
  frame24,
  frame25,
  frame26,
  frame27,
  frame28,
  frame29,
  frame30,
  frame31,
  frame32,
  frame33,
  frame34,
  frame35,
  frame36,
  frame37,
  frame38,
  frame39,
  frame40,
  frame41,
  frame42,
  frame43,
  frame44,
  frame45,
  frame46,
  frame47,
  frame48,
  frame49,
  frame50,
  frame51,
  frame52,
  frame53,
  frame54,
  frame55,
  frame56,
  frame57,
  frame58,
  frame59,
];
